import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './Navbar/Navbar'; 
import Footer from './Home/Footer'; 
import Home from './Home/Home';
import Chart from './Home/Chart';
import Sattachart from './Home/Sattachart';
import Allmarket from './Home/Allmarket';
import Privacypolicy from './Home/Privacypolicy';
import TermsConditions from './Home/Termsandcondition';
import Markets from './Home/Markets';  // Ensure you import the Markets component
import ClearApplicationCache from "./ClearApplicationCache";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Layout with Navbar and Footer */}
        <Route
          path="/"
          element={
            <div>
                    <ClearApplicationCache />

              <Navbar />
              <Home />
              <Chart />
              <Allmarket />
              <Sattachart />
              <Footer />
            </div>
          }
        />
        <Route
          path="/privacypolicy"
          element={
            <div>
              {/* <Navbar /> */}
              <Privacypolicy />
              {/* <Footer /> */}
            </div>
          }
        />
        <Route
          path="/termsconditions"
          element={
            <div>
              {/* <Navbar /> */}
              <TermsConditions />
              {/* <Footer /> */}
            </div>
          }
        />
        
        {/* Route for Markets without Navbar and Footer */}
        <Route path="/Markets" element={<Markets />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
